<template>
  <div id="app">
    <component :is="layout" :key="$route.fullPath">
      <RouterView ref="routerView" :key="$route.fullPath" />
    </component>
  </div>
</template>

<script>
import { useCookiebot } from "@ambitiondev/vue-cookiebot"
import { useAuthStore } from "@/store/modules/auth"
import { useCustomerStore } from "@/store/modules/customer"
import { useProjectStore } from "@/store/modules/project"
import { useConfigStore } from "@/store/modules/config"

if (process.env.VUE_APP_ENV === "production") {
  const w = window
  const d = document
  const s = "script"
  const l = "dataLayer"
  const i = "GTM-W27W7X5"
  w[l] = w[l] || []
  w[l].push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js"
  })
  const f = d.getElementsByTagName(s)[0],
    j = d.createElement(s),
    dl = l !== "dataLayer" ? "&l=" + l : ""
  j.async = true
  j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl
  f.parentNode.insertBefore(j, f)
}

const default_layout = "default"
// import "@/styles/_custom.scss";
export default {
  name: "App",
  setup() {
    const customerStore = useCustomerStore()
    const projectStore = useProjectStore()
    const authStore = useAuthStore()
    const configStore = useConfigStore()

    return {
      customerStore,
      projectStore,
      authStore,
      configStore
    }
  },
  data() {
    return {
      showNotify: false
    }
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout"
    },
    windowTitle() {
      // route-name is part of the localisation-key
      return `${this.$t(this.$route.meta.title ?? "")} - ${this.$t("IoT Portal")}`
    }
  },
  watch: {
    windowTitle: "setWindowTitle",
    "authStore.user": function () {
      this.loadData()
    }
  },
  mounted() {
    if (process.env.VUE_APP_ENV === "production") {
      const { consentBanner } = useCookiebot()
      consentBanner()
    }
    /*let now = window.location.pathname.toString();
    let number = 0;
    window.onpopstate = function() {
      number++;
      console.log(number);
      let path = window.location.pathname.toString();
      console.log(now + ", " + path);
      console.log();
    };*/
  },
  created() {
    this.setWindowTitle()
    this.configStore.setLang()

    this.$store.dispatch("menu/AutoHideMenu")
    this.configStore.checkRadioHelp()
    this.loadData()
  },
  methods: {
    setWindowTitle() {
      document.title = this.windowTitle
    },
    async loadData() {
      if (this.authStore.user) {
        await this.customerStore.getCustomerList()
        this.customerStore.autoSetCustomer()
        await this.projectStore.getProjectList()
        this.projectStore.autoSetProject()
        // apiUser gates most of the shell and is otherwise only refreshed by setProject() /
        // the project-changer watcher — neither of which fires when the customer has no
        // project at all. Load it here so the "no project" screen can render.
        await this.authStore.getApiUser()
        // project-changer.vue:249 sets these flags reactively when mounted (Default.vue layout).
        // On admin layouts (NoSidebar.vue) it is not mounted, so run the cascade explicitly here.
        if (this.projectStore.projectList.length === 0) {
          this.configStore.setNoProjectVisible({
            noProjectVisible: true,
            noProjectVisiblePageInfo: true
          })
        }
        this.authStore.redirectAfterLogin()
      }
    }
  }
}
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Nunito:wght@200;300;400;600;700;800;900&display=swap");
</style>
